import view from './view.html';

/* @ngInject */
export default function () {
	return {
		template:                   view,
		replace:                    true,
		scope:                      true,
		controller: /* @ngInject */ ($scope, STATUSES, $http, DataTablesService, moment, ReportsService, Reports, StaffReportsAdverseEventsService, toastr) => {
			$scope.start = $scope.parameters.start;
			$scope.end   = $scope.parameters.end;

			const financialYear = ReportsService.financialYear();
			$scope.moment       = moment;

			if (!$scope.start) {
				$scope.start = financialYear.start;
			}

			if (!$scope.end) {
				$scope.end = financialYear.end;
			}

			$scope.status = STATUSES.UNLOADED;

			$scope.dataTable = DataTablesService.configure({
				id:                 $scope.reportId,
				title:              'Adverse Events Individual Report',
				// frozenColumns:      true,
				reorderableColumns: true,
			}, {
				// frozenLeftColumns: 1,
				order:             [
					[
						2,
						'desc',
					],
				],
			});

			$scope.data  = [];
			$scope.error = null;

			$scope.resolveOne = (eventId) => {
				const event = $scope.data.find((item) => {
					return item['Event Id'] === eventId;
				});

				if (event) {
					event['Has AE Been Resolved?'] = true;

					StaffReportsAdverseEventsService.resolveOne(eventId)
					                                .then((response) => {
						                                toastr.clear();
						                                toastr.success('The adverse event was successfully resolved.', 'Success');
					                                })
					                                .catch((error) => {
						                                event['Has AE Been Resolved?'] = false;

						                                toastr.clear();
						                                toastr.error('There was an error while resolving the adverse event, please try again.', 'Error');
					                                });
				}
			};

			$scope.refresh = () => {
				$scope.status = STATUSES.LOADING;

				$scope.data  = [];
				$scope.error = null;

				return Reports.one($scope.reportId)
				              .one('execute')
				              .get({
					              start: $scope.start.format(),
					              end:   $scope.end.format(),
				              })
				              .then((data) => {
					              $scope.data  = data;
					              $scope.error = null;

					              $scope.status = STATUSES.LOADED;

					              return data;
				              })
				              .catch((error) => {
					              $scope.data  = [];
					              $scope.error = error;

					              $scope.status = STATUSES.ERRORED;
				              });
			};

			$scope.refresh();
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/report/reports/B93ACCFA-1495-49EB-A24F-F82EF2A9DD14/index.js